import { useQuery } from 'react-query';

import { getObjectVuls } from 'api/vulnerabilities/getObjectVuls';

export const useGetObjectVuls = (slug: string, enabled: boolean = true, filter: string = 'default') => {
  const { data, refetch, isLoading, isFetching } = useQuery(
    ['objectVuls', slug, filter],
    () => getObjectVuls(slug, filter),
    {
      enabled,
      refetchOnWindowFocus: false,
    },
  );

  return { data, refetch, isLoading, isFetching };
};

export default useGetObjectVuls;
